import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const SHEET_URL =
  "https://opensheet.elk.sh/1Nh8T2uQ0Gc2kqsgQzTRFdq4aD36KTD5zOckCDbrJjVA/Tickets";

const TicketsList = () => {
  const [tickets, setTickets] = useState([]);

  useEffect(() => {
    fetch(SHEET_URL)
      .then((res) => res.json())
      .then(setTickets);
  }, []);

  return (
    <div className="container mt-4">
      <h2 className="mb-4 fw-bold text-primary">All Tickets</h2>
      <div className="table-responsive">
        <table className="table table-hover table-bordered align-middle">
          <thead className="table-light">
            <tr>
              <th>Ticket ID</th>
              <th>Name</th>
              <th>Subject</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {tickets.length === 0 ? (
              <tr>
                <td colSpan="5" className="text-center text-muted py-4">
                  No tickets found.
                </td>
              </tr>
            ) : (
              tickets.map((ticket, idx) => (
                <tr key={idx}>
                  <td>{ticket.TicketID}</td>
                  <td>{ticket.Name}</td>
                  <td>{ticket.Subject}</td>
                  <td>
                    <span
                      className={`badge ${
                        ticket.Status === "Pending"
                          ? "bg-warning text-dark"
                          : "bg-success"
                      }`}
                    >
                      {ticket.Status}
                    </span>
                  </td>
                  <td>
                    <Link
                      to={`/tickets/${ticket.TicketID}`}
                      className="btn btn-sm btn-outline-primary"
                    >
                      View
                    </Link>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TicketsList;
